import { Box, Grid, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./ProductDetailsCheckoutContent.styles";
import { IPricesHistorical, ProductDetailsHistoricalBox } from "./ProductDetailsHistoricalBox";
import { ProductDetailsSubscriptionBox } from "./ProductDetailsSubscriptionBox";

export interface IProps extends WithStyles<typeof styles> {
    subscriptionEnabled: boolean;
    otpEnabled: boolean;
    prices: {
        historical: IPricesHistorical,
    };
    handleCheckoutSubscription: any;
    handleCheckoutHistorical: any;
    handleDateChange: any;
    rowId: any;
    from: string;
    to: string;
    headlineDisabled?: boolean;
    remark?: string;
    isAlreadySubscribed?: boolean;
    hideInterval?: boolean;
    showBusinessDays?: boolean;
}

const CheckoutContentPure: React.FunctionComponent<IProps> = ({
                                                                  otpEnabled,
                                                                  subscriptionEnabled,
                                                                  handleCheckoutSubscription,
                                                                  handleCheckoutHistorical,
                                                                  handleDateChange,
                                                                  prices,
                                                                  rowId,
                                                                  from,
                                                                  to,
                                                                  headlineDisabled,
                                                                  remark,
                                                                  isAlreadySubscribed,
                                                                  hideInterval,
                                                                  showBusinessDays,
                                                                  classes
                                                              }: IProps) => {

    return <>
        <Box>
            <Grid container justify="center" direction="row" spacing={4}>
                {otpEnabled ?
                    <ProductDetailsHistoricalBox disabled={hideInterval}
                                                 headlineDisabled={headlineDisabled}
                                                 rowId={rowId} handleCheckout={handleCheckoutHistorical}
                                                 handleDateChange={handleDateChange}
                                                 from={from}
                                                 to={to}
                                                 remark={remark}
                                                 prices={prices.historical}
                                                 showBusinessDays={showBusinessDays}
                    />
                    : null}
                {subscriptionEnabled ?
                    <ProductDetailsSubscriptionBox
                        headlineDisabled={headlineDisabled}
                        rowId={rowId}
                        handleCheckout={handleCheckoutSubscription}
                        isAlreadySubscribed={isAlreadySubscribed}
                    />
                    : null}

            </Grid>
        </Box>
    </>;
};

export const ProductDetailsCheckoutContent = withStyles(styles)(CheckoutContentPure);
